import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import {
  deliveryRpc,
  type DeliveryFilters,
  type DeliveryRow,
  type DeliveryDetail,
} from '@/lib/deliveries';

export function useDeliveryContract() {
  const { organization, profile, access, can } = useAuth();
  return useQuery({
    queryKey: ['delivery_contract', organization?.id, profile?.id, access?.access_version],
    queryFn: ({ signal }) =>
      deliveryRpc<{ version: number; bulk_limit: number }>('get_delivery_contract', {}, signal),
    enabled: !!organization?.id && can('sales.view'),
    retry: false,
    staleTime: 60000,
  });
}
export function useDeliveries(filters: DeliveryFilters) {
  const { organization, profile, access, can } = useAuth();
  return useQuery({
    queryKey: ['deliveries', organization?.id, profile?.id, access?.access_version, filters],
    queryFn: ({ signal }) =>
      deliveryRpc<{
        rows: DeliveryRow[];
        total: number;
        status_counts: Record<string, number>;
        as_of: string;
      }>('list_sale_deliveries', { p_filters: filters }, signal),
    enabled: !!organization?.id && can('sales.view'),
    retry: false,
    refetchInterval: 60000,
  });
}
export function useDelivery(id?: string) {
  const { organization, profile, access, can } = useAuth();
  return useQuery({
    queryKey: ['delivery', organization?.id, profile?.id, access?.access_version, id],
    queryFn: ({ signal }) =>
      deliveryRpc<DeliveryDetail>('get_sale_delivery', { p_sale_id: id }, signal),
    enabled: !!id && !!organization?.id && can('sales.view'),
    retry: false,
    refetchInterval: 60000,
  });
}
